import SipCallsAPI from 'dashboard/api/channel/sip/sipCallsAPI';
import { createVoiceWebrtcSession } from 'dashboard/composables/useVoiceWebrtcSession';

// Thin SIP wrapper over the generic WebRTC plumbing in useVoiceWebrtcSession.js.
// Module-scoped instance → state is a singleton across every composable caller
// (header button + contact-panel button + bubble), same pattern as
// useWhatsappCallSession.js. No onInitiateError mapping needed — SIP has no
// WhatsApp/Meta permission-template (422) concept.
const session = createVoiceWebrtcSession({
  api: SipCallsAPI,
  apiUrlSegment: 'sip_calls',
  remoteAudioElementId: 'sip-call-remote-audio',
  logLabel: '[SIP Call]',
});

export const hasActiveSipCall = () => session.hasActiveCall();

export const isLocalSipCall = callId => session.isLocalCall(callId);

export function useSipCallSession() {
  return session.useSession();
}

// Cable handlers fire outside any composable instance, so the shared session
// surface is exposed as module-level functions for them.

export const applySipOutboundAnswer = (callId, sdpAnswer) =>
  session.applyRemoteAnswer(callId, sdpAnswer);

export const armSipOutboundRecorder = () => session.armOutboundRecorder();

export const cleanupSipSession = () => session.cleanupSession();

export const handleSipRemoteEnd = callId => session.handleRemoteEnd(callId);

export const setSipCallMuted = muted => session.setMuted(muted);

export const sendSipTerminateBeacon = () => session.sendTerminateBeacon();
